import React from 'react';
import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="list layout" {...props} />;
}

export const meta = {
  id: 'Cmspagessections',
  title: 'Cmspagessections',
  category: 'CMS',
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: ``,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 940,
    height: 740
  }
};
